import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import arrowBackFill from '@iconify/icons-eva/arrow-back-fill';
// routes
import { PATH_ADMIN } from '../../routes/paths';

// ----------------------------------------------------------------------

const icon = (iconObj) => <Icon icon={iconObj} width={22} height={22} />;

export default function useAdminNavConfig(translate) {
  return [
    {
      subheader: translate('admin.nav.manage'),
      items: [
        { title: translate('admin.nav.users'), path: PATH_ADMIN.users, icon: icon(peopleFill) },
        { title: translate('admin.nav.audit'), path: PATH_ADMIN.audit, icon: icon(fileTextFill) },
      ],
    },
    {
      subheader: translate('admin.nav.app'),
      items: [
        { title: translate('admin.nav.backToApp'), path: '/dashboard', icon: icon(arrowBackFill) },
      ],
    },
  ];
}
